import { Box, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../hooks/use-open-article-by-editor-host';
import { isEditor3Host } from '../../../utils/get-editor-host';
export const ManualTasksList = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const onContrastCheckerClick = () => {
    openSelectedArticle(editorHost, 'editor-package-accessibility-wizard.articles-incomplete-components-help.contrast-checker');
    biLogger.ctaClick({
      ctaName: BiCtaNames.ContrastChecker
    });
  };
  const manualTasks = [{
    ariaLabel: t('accessibility-wizard.manual-tasks.descriptive-link-button.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-link-text-help',
    description: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP3"
    }, /*#__PURE__*/React.createElement(Text, {
      listStyle: "circle",
      size: "tiny",
      secondary: true
    }, t('accessibility-wizard.manual-tasks.descriptive-link-button.description')), isEditor3Host(editorHost) && /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP1"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        bold: /*#__PURE__*/React.createElement(Text, {
          size: "tiny",
          weight: "bold"
        })
      },
      i18nKey: "accessibility-wizard.manual-tasks.descriptive-link-button.good-example"
    })), /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        bold: /*#__PURE__*/React.createElement(Text, {
          size: "tiny",
          weight: "bold"
        })
      },
      i18nKey: "accessibility-wizard.manual-tasks.descriptive-link-button.bad-example"
    })))),
    learnMore: t('accessibility-wizard.manual-tasks.descriptive-link-button.learn-more'),
    title: t('accessibility-wizard.manual-tasks.descriptive-link-button.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.information-colors.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-using-color-help',
    description: t('accessibility-wizard.manual-tasks.information-colors.description'),
    learnMore: t('accessibility-wizard.manual-tasks.information-colors.learn-more'),
    title: t('accessibility-wizard.manual-tasks.information-colors.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.text-in-image.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-text-in-images-help',
    description: t('accessibility-wizard.manual-tasks.text-in-image.description'),
    learnMore: t('accessibility-wizard.manual-tasks.text-in-image.learn-more'),
    title: t('accessibility-wizard.manual-tasks.text-in-image.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.media.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-media-alternatives-help',
    description: t('accessibility-wizard.manual-tasks.media.description'),
    learnMore: t('accessibility-wizard.manual-tasks.media.learn-more'),
    title: t('accessibility-wizard.manual-tasks.media.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.controls.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-media-control-alternatives-help',
    description: /*#__PURE__*/React.createElement(Trans, {
      components: {
        bold: /*#__PURE__*/React.createElement(Text, {
          size: "tiny",
          weight: "bold",
          secondary: true
        })
      },
      i18nKey: "accessibility-wizard.manual-tasks.controls.description"
    }),
    learnMore: t('accessibility-wizard.manual-tasks.controls.learn-more'),
    title: t('accessibility-wizard.manual-tasks.controls.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.zoom-levels.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-zoomed-content-help',
    description: t('accessibility-wizard.manual-tasks.zoom-levels.description'),
    learnMore: t('accessibility-wizard.manual-tasks.zoom-levels.learn-more'),
    title: t('accessibility-wizard.manual-tasks.zoom-levels.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.accessibility-statement.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-accessibility-statement-help',
    description: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "SP1"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, t('accessibility-wizard.manual-tasks.accessibility-statement.description')), /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, t('accessibility-wizard.manual-tasks.accessibility-statement.description.to-do-this'))), /*#__PURE__*/React.createElement(Text, {
      listStyle: "circle",
      size: "tiny",
      secondary: true
    }, /*#__PURE__*/React.createElement("ul", {
      style: {
        padding: '0'
      }
    }, /*#__PURE__*/React.createElement("li", {
      style: {
        margin: '0'
      }
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        Link: /*#__PURE__*/React.createElement(TextButton, {
          size: "tiny",
          skin: "dark",
          underline: "always",
          secondary: true,
          onClick: () => {
            biLogger.ctaClick({
              ctaName: BiCtaNames.W3CStatementGenerator
            });
            window.open(t('accessibility-wizard.manual-tasks.accessibility-statement.description-li.1.link'), '_blank');
          }
        })
      },
      i18nKey: "accessibility-wizard.manual-tasks.accessibility-statement.description-li.1"
    })), /*#__PURE__*/React.createElement("li", {
      style: {
        margin: '0'
      }
    }, t('accessibility-wizard.manual-tasks.accessibility-statement.description-li.2')), /*#__PURE__*/React.createElement("li", {
      style: {
        margin: '0'
      }
    }, t('accessibility-wizard.manual-tasks.accessibility-statement.description-li.3'))))),
    learnMore: t('accessibility-wizard.manual-tasks.accessibility-statement.learn-more'),
    title: t('accessibility-wizard.manual-tasks.accessibility-statement.title')
  }, {
    ariaLabel: t('accessibility-wizard.manual-tasks.color-contrast-manual.aria-label'),
    articleKey: 'editor-package-accessibility-wizard.articles-color-contrast-manual-help',
    description: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, /*#__PURE__*/React.createElement(Trans, {
      components: {
        contrastChecker: /*#__PURE__*/React.createElement(TextButton, {
          size: "tiny",
          skin: "dark",
          underline: "always",
          secondary: true,
          onClick: onContrastCheckerClick
        })
      },
      i18nKey: "accessibility-wizard.manual-tasks.color-contrast-manual.description"
    })),
    learnMore: t('accessibility-wizard.manual-tasks.color-contrast-manual.learn-more'),
    title: t('accessibility-wizard.manual-tasks.color-contrast-manual.title')
  }];
  return manualTasks;
};
//# sourceMappingURL=manual-tasks.js.map